import { createContext } from "react";
import get from "lodash.get";

// Create multiple contexts that we can pull data from on every page
export const LayoutContext = createContext();
LayoutContext.displayName = "LayoutContext";

export const ResourceContext = createContext();
ResourceContext.displayName = "ResourceContext";

export const TaxonomyContext = createContext();
TaxonomyContext.displayName = "TaxonomyContext";

export const AuthorContext = createContext();
AuthorContext.displayName = "AuthorContext";

export const DataContext = createContext();
DataContext.displayName = "DataContext";

export default function ContentContext({
    children,
    layout,
    type,
    data,
    author,
    taxonomy
}) {
    const foundAuthor = author || getAuthor(data);

    return (
        <LayoutContext.Provider value={layout}>
            <ResourceContext.Provider value={type}>
                <AuthorContext.Provider value={foundAuthor}>
                    <TaxonomyContext.Provider value={taxonomy}>
                        {children}
                    </TaxonomyContext.Provider>
                </AuthorContext.Provider>
            </ResourceContext.Provider>
        </LayoutContext.Provider>
    );
}

/**
 * Global hooks to scrub incoming REST data to map to context providers.
 */

export function getAuthor(data) {
    // Author pages pass their data directly
    if (data && data.type === "author") return data;

    const author = get(data, "_embedded.author", null);
    if (!author) return null;

    if (author.length) return author[0];
    return author;
}
